export const QUERY__MANAGED_METHODS = 'managedMethods';
